import { render, staticRenderFns } from "./detailData.vue?vue&type=template&id=5db7dbdf&scoped=true&"
import script from "./detailData.vue?vue&type=script&lang=js&"
export * from "./detailData.vue?vue&type=script&lang=js&"
import style0 from "./detailData.vue?vue&type=style&index=0&id=5db7dbdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7dbdf",
  null
  
)

export default component.exports